var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31545 9.56414C7.88583 9.56414 7.53912 9.23129 7.53912 8.81886C7.53912 8.40642 7.88583 8.06634 8.31545 8.06634C8.74507 8.06634 9.09932 8.40642 9.09932 8.81886C9.09932 9.23129 8.74507 9.56414 8.31545 9.56414ZM4.78803 9.56414C4.35841 9.56414 4.00416 9.23129 4.00416 8.81886C4.00416 8.40642 4.35841 8.06634 4.78803 8.06634C5.21765 8.06634 5.56436 8.40642 5.56436 8.81886C5.56436 9.23129 5.21765 9.56414 4.78803 9.56414ZM9.61938 4.39062H3.71774C2.34597 4.39062 1.23047 5.46151 1.23047 6.77839V10.6495C1.23047 11.9592 2.34597 13.03 3.71774 13.03H4.33579C4.62221 13.03 4.89355 13.1386 5.09705 13.3339L5.92614 14.1299C6.12211 14.318 6.38591 14.4265 6.6648 14.4265C6.94368 14.4265 7.20748 14.318 7.41099 14.1299L8.24008 13.3339C8.43604 13.1386 8.70738 13.03 8.9938 13.03H9.61938C10.9836 13.03 12.0991 11.9592 12.0991 10.6495V6.77839C12.0991 5.46151 10.9836 4.39062 9.61938 4.39062Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31521 9.5642C7.88559 9.5642 7.53888 9.23136 7.53888 8.81892C7.53888 8.40648 7.88559 8.06641 8.31521 8.06641C8.74483 8.06641 9.09908 8.40648 9.09908 8.81892C9.09908 9.23136 8.74483 9.5642 8.31521 9.5642ZM4.78777 9.5642C4.35815 9.5642 4.00391 9.23136 4.00391 8.81892C4.00391 8.40648 4.35815 8.06641 4.78777 8.06641C5.2174 8.06641 5.56411 8.40648 5.56411 8.81892C5.56411 9.23136 5.2174 9.5642 4.78777 9.5642Z",
    fill: "#1080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6943 1.62695H6.79268C5.67475 1.62695 4.72502 2.33729 4.42005 3.31262C4.3924 3.40105 4.46414 3.48653 4.56031 3.48653H9.61913C11.5034 3.48653 13.041 4.96262 13.041 6.7788V10.0715C13.041 10.1593 13.122 10.2271 13.2114 10.209C14.3332 9.98263 15.174 9.02252 15.174 7.87863V4.0075C15.174 2.69784 14.0585 1.62695 12.6943 1.62695Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.d2a2acd105b5ac2122acefc8e4dc5c71.svg";
export { ForwardRef as ReactComponent };